














import { Component, Vue, Prop, Watch, Emit } from 'vue-property-decorator'
import { stopBodyScroll, allowRefreshOrShare } from '@utils/index'
import BigItem from './bigItem.vue'
import { Popup } from 'vant'

@Component({
  components: {
    BigItem,
    [Popup.name]: Popup,
  },
})
export default class CouponAll extends Vue {
  @Prop({ default: false }) readonly show!: boolean
  @Prop({ default: [] }) readonly items!: any[]

  isShow = false

  close() {
    this.$emit('hide')
  }

  @Watch('show')
  onChangeShow(val: boolean) {
    this.isShow = val
  }

  @Emit()
  receiveCoupon(item: any) {
    return item
  }
}
